import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import AppContext from 'context/Context';

const EcomStatItem = ({ stat }) => {
  const { config } = useContext(AppContext);
  const { isDark } = config;
  const textColor = isDark ? '#fff' : '#212529';
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: 'none', borderBottom: '1px solid #ccc' }}>
      <h6 style={{ margin: '0', fontSize: '0.875rem', fontWeight: 'bold' }}>{stat.title}</h6>
      <p style={{ margin: '0', fontSize: '1.25rem' ,color: textColor}}>{stat.amount}</p>
    </div>
  );
};

EcomStatItem.propTypes = {
  stat: PropTypes.shape({
    title: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
    percent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string
  }),
  index: PropTypes.number,
  lastIndex: PropTypes.number
};

const EcomStat = ({data}) => {

  const chartData = [
    {
      title: 'Total support tickets',
      amount: data.totalTickets,
},
    {
      title: 'Resolved',
      amount: data.totalTicketsResolved,
},
    {
      title: 'Permanently Resolved',
      amount: data.totalTicketsPermenentlyResolved
 },
    {
      title: 'Temporary  Resolved',
      amount: data.totalTicketsTemporaryResolved
     },
    {
      title: 'Pending',
      amount: data.totalTicketsPending
    }
  ];
  


  return (
    <>
        <Row className="g-0">
          {chartData.map((stat, index) => (
            <EcomStatItem
              key={stat.title}
              stat={stat}
              index={index}
              lastIndex={chartData.length - 1}
            />
          ))}
        </Row>

    </>
  );
};

EcomStat.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default EcomStat;
